var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"group-grid"},_vm._l((_vm.groups),function(group,i){return _c('GroupTile',{key:group.name,attrs:{"group":group}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }